<template>
  <div class="benefits">
    <h1>Benefits for {{ headerName }}</h1>
    <h2>Total Savings for {{ year }}:&nbsp; {{ totalSavings | toCurrency }}</h2>
    <h2>Available Discounts</h2>

    <b-table
       :data="discounts">
      <b-table-column field="name"
                      label="Discount"
                      v-slot="props">
        {{ props.row.name }}
      </b-table-column>
      <b-table-column field="name"
                      :label="year + ' Total'"
                      numeric
                      v-slot="props">
        {{ props.row.total | toCurrency }}
      </b-table-column>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                 icon="fas fa-sad-tear"
                 size="is-large">
              </b-icon>
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
    name: 'Benefits',
    data() {
        return {
            customerNumber: null,
            year: null,
            totalSavings: 0,
            discounts: [],
            inited: false,
        }
    },
    computed: {
        headerName: function() {
            if (! this.$store.state.user.uuid) {
                return ""
            }
            let name = this.$store.state.user.display_name
            if (this.customerNumber) {
                return name + " #" + this.customerNumber
            }
            return name
        },
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // go ahead and fetch data if someone is logged in
            if (this.$store.state.user.uuid) {
                this.fetchData()
            } else { // send logged-out users to "login" instead
                this.$router.push('/login')
            }

            // we did it!
            this.inited = true
        },

        fetchData() {
            this.$http.get('/api/my/benefits').then(response => {
                if (response.data.error) {
                    // TODO: should be smarter than just knee-jerk redirect?
                    this.$router.push('/')
                } else {
                    this.customerNumber = response.data.customer_number
                    this.year = response.data.year
                    this.totalSavings = response.data.total_savings
                    // we only want to show discounts which have a total
                    this.discounts = response.data.discounts.filter(function(dsc) {
                        return dsc.total != 0
                    })
                }
            }, response => {
                // TODO: should be smarter than just knee-jerk redirect?
                this.$router.push('/')
            })
        },
    },
}
</script>
